// set
const html = document.documentElement.style,
      body = document.body.style,
      breakpoint = window.matchMedia('(min-width: 768px)')


// vh
function setHeight(){
  let vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}
setHeight()
window.addEventListener('resize', setHeight)


// loader
const loader = document.querySelector('.c-loader')
window.addEventListener('load', function(){
  loader.classList.add('is-anima')
  setTimeout(() => { loader.style.display = 'none'; }, 600)
})


// navi sticky
const sticky = document.querySelector('.l-header'),
      fposi = 300
let iposi = 0

window.addEventListener('scroll', function(){
  let wposi = window.scrollY
  if(fposi <= wposi && iposi <= wposi){ sticky.classList.add('is-disable') }
  else{ sticky.classList.remove('is-disable') }
  iposi = wposi
})


// navi menu
const menuIcon = document.querySelector('.l-header__toggle'),
      menuList = document.querySelector('.l-header__navigation'),
      elements = document.querySelectorAll('.l-header__menu > li')

function classAdd(){
  menuIcon.classList.add('is-active')
  menuList.classList.add('is-active')
  html.overflow = 'hidden'
  body.overflow = 'hidden'
  let i = 1
  Array.prototype.forEach.call(elements, element => {
    setTimeout(() => {element.classList.add('is-anima')}, 120 * i)
    i++
  })
}
function classRemove(){
  menuIcon.classList.remove('is-active')
  menuList.classList.remove('is-active')
  html.overflow = ''
  body.overflow = ''
  Array.prototype.forEach.call(elements, element => {
    element.classList.remove('is-anima')
  })
}

window.addEventListener('resize', function(){
  if(breakpoint.matches === true){ classRemove() }
})
menuIcon.addEventListener('click', function(){
  if(this.classList.contains('is-active')){ classRemove() }
  else{ classAdd() }
})


// totop
const totop = document.querySelector('.l-footer__totop')
window.addEventListener('scroll', function(){
  if(window.scrollY > 600){ totop.classList.add('is-active') }
  else{ totop.classList.remove('is-active')}
})


// contact
const formError = document.querySelectorAll('.error')
for(let i = 0; i < formError.length; i++){
  formError[i].parentElement.classList.add('is-error')
}


// swiper
if(document.querySelector('.p-top-intro__swiper1')){
  new Swiper('.p-top-intro__swiper1', {
    allowTouchMove: false,
    loop: true,
    loopedSlides: 4,
    slidesPerView: 'auto',
    spaceBetween: 32,
    speed: 16000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false
    }
  })
}
if(document.querySelector('.p-top-intro__swiper2')){
  new Swiper('.p-top-intro__swiper2', {
    allowTouchMove: false,
    loop: true,
    loopedSlides: 4,
    slidesPerView: 'auto',
    slidesOffsetBefore: 170,
    spaceBetween: 32,
    speed: 16000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: {
        slidesOffsetBefore: 200,
      }
    }
  })
}
